'use strict';

import React, {Component} from 'react';

class UnreadCount extends Component {
	render() {
		if ( ! this.props.hasUnread ) {
			return null;
		}
		return (
			<span className="msg-count pulse-red">
				{this.props.hasUnread}
			</span>
		);
	}
}


UnreadCount.displayName = 'UnreadCount';
UnreadCount.propTypes = {
	hasUnread: React.PropTypes.oneOfType([
		React.PropTypes.number,
		React.PropTypes.bool
	])
};

export default UnreadCount;



// WEBPACK FOOTER //
// ./src/components/UnreadCount.js